import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { ReactNode } from "react";

type Props = {
  itemId: string;
  children: ReactNode;
  activeOpacity?: number;
};

export const SortableContainer = ({
  itemId,
  children,
  activeOpacity = 0.3,
}: Props) => {
  const { active, attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: itemId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: itemId === active?.id ? activeOpacity : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </div>
  );
};
